/// <reference path="../../include.ts" />
namespace gpx_visualizer_phase2 {

	import View = alm.view.View;
	import IButton = alm.view.IButton;
	import ButtonBehavior = alm.view.ButtonBehavior;

	export class PushButton extends View<JQuery> implements IButton {

		// --------------------------------------------------
		//
		// CONSTRUCTOR
		//
		// --------------------------------------------------

		constructor(view:JQuery) {
			super(view);

			this.initialize();
		}





		// --------------------------------------------------
		//
		// METHOD
		//
		// --------------------------------------------------

		protected implInitialize():JQuery {
			const view = this.getView();

			this.behavior = new ButtonBehavior(this, view.get(0));

			return view;
		}

		protected implReady():void {
		}

		protected implFinalize():void {
		}

		protected implShow(view:JQuery, useTransition:boolean):cmd.Command {
			return new cmd.Func(():void => {
				view.css('display', 'block');
			});
		}

		protected implHide(view:JQuery, useTransition:boolean):cmd.Command {
			return new cmd.Func(():void => {
				view.css('display', 'none');
			});
		}





		public implButtonOver(useTransition:boolean):void {
		}

		public implButtonOut(useTransition:boolean):void {
		}

		public implButtonDown(useTransition:boolean):void {
			if (this.behavior.getIsEnabled()) {
				trace('[PushButton] down');
				AudioPlayer.getInstance().getClip(AudioId.hi).play();
				this.dispatchEventType('click', this);
			}
		}

		public implButtonUp(useTransition:boolean):void {
		}

		public implButtonClick(useTransition:boolean):void {
		}

		public implButtonChangeEnabled(isEnabled:boolean, useTransition:boolean):void {
			this.getView().css('opacity', isEnabled ? 1 : 0.3);
		}




		public setIsEnabled(value:boolean):void {
			this.behavior.setIsEnabled(value);
		}





		// --------------------------------------------------
		//
		// VARIABLE
		//
		// --------------------------------------------------

		private behavior:ButtonBehavior;
	}
}
